import { render } from "./ProductFutureWineListPage.vue?vue&type=template&id=76447ede&scoped=true"
import script from "./ProductFutureWineListPage.vue?vue&type=script&lang=js"
export * from "./ProductFutureWineListPage.vue?vue&type=script&lang=js"

import "./ProductFutureWineListPage.vue?vue&type=style&index=0&id=76447ede&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-76447ede"

export default script